"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var interfaces_1 = require("@hudled/interfaces");
var material_1 = require("@mui/material");
var firestore_1 = require("firebase/firestore");
var react_1 = __importDefault(require("react"));
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_dom_1 = require("react-router-dom");
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var hooks_1 = require("containers/Onboarding/hooks");
var HoCs_1 = require("utils/HoCs");
var hooks_2 = require("utils/hooks");
var ordered_1 = require("utils/selectors/ordered");
var single_1 = require("utils/selectors/single");
var Wizard_1 = require("../Wizard");
var TeamCreationSteps_1 = __importDefault(require("./TeamCreationSteps"));
var TeamsDetailsWrapper_1 = __importDefault(require("./TeamsDetailsWrapper"));
var TeamsPreview_1 = __importDefault(require("./TeamsPreview"));
var utils_1 = require("./utils");
var WizardParts_1 = require("./WizardParts");
var TeamCreationWizard = (0, Wizard_1.makeWizard)(WizardParts_1.TeamCreationWizardContext);
var STEPS_WITHOUT_ASSIGN_LEADS = interfaces_1.TEAM_CREATION_STEPS.filter(function (s) { return s !== 'ASSIGN_LEADS'; });
var STEPS_WITHOUT_SET_MY_TEAM = STEPS_WITHOUT_ASSIGN_LEADS.filter(function (s) { return s !== 'SET_MY_TEAM_BASE'; });
var TeamCreation = function () {
    var _a;
    var companyTeams = (0, react_redux_1.useSelector)(ordered_1.selectCompanyTeams);
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var history = (0, react_router_dom_1.useHistory)();
    var STEPS = ((_a = company === null || company === void 0 ? void 0 : company.completedOnboardingSteps) === null || _a === void 0 ? void 0 : _a.includes('TEAMS_CREATION'))
        ? STEPS_WITHOUT_SET_MY_TEAM
        : STEPS_WITHOUT_ASSIGN_LEADS;
    var _b = __read((0, hooks_2.useSubmitter)('companies', company === null || company === void 0 ? void 0 : company.id), 1), updateCompany = _b[0];
    var addCompanyOnboardingStep = (0, hooks_1.useAddCompanyOnboardingStep)();
    var initialStep = react_1.default.useMemo(function () { return STEPS.find(function (step) { var _a; return !((_a = company === null || company === void 0 ? void 0 : company.teamCreationSteps) === null || _a === void 0 ? void 0 : _a.includes(step)); }); }, []);
    if (!(0, react_redux_firebase_1.isLoaded)(companyTeams)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    var addStep = function (currentStep) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!!((_a = company === null || company === void 0 ? void 0 : company.teamCreationSteps) === null || _a === void 0 ? void 0 : _a.includes(currentStep))) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateCompany({ teamCreationSteps: (0, firestore_1.arrayUnion)(currentStep) })];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var teams = companyTeams || [];
    var initialValues = { teams: teams, emails: Object.fromEntries(teams.map(function (t) { return [t.id, t.leadEmail]; })) };
    return ((0, jsx_runtime_1.jsx)(TeamCreationWizard, __assign({ steps: STEPS, initialStep: initialStep, onEnd: function () { return addCompanyOnboardingStep('TEAMS_CREATION').then(function () { return history.push('/dashboard'); }); }, onNextStep: addStep }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: function () { return undefined; }, initialValues: initialValues, keepDirtyOnReinitialize: true, validate: utils_1.oneOfEachEmail }, { children: function () { return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, sx: { height: '100%' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, sm: 12, md: 5, item: true }, { children: (0, jsx_runtime_1.jsx)(TeamCreationSteps_1.default, {}) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ md: 7, item: true, height: "100%", bgcolor: "green.main" }, { children: (0, jsx_runtime_1.jsx)(TeamsPreview_1.default, { TeamsDetailsWrapper: TeamsDetailsWrapper_1.default }) }))] }))); } })) })));
};
exports.default = (0, HoCs_1.HasCompanyHoC)(TeamCreation);
